import { ChevronRight } from "lucide-react";

const FilterCard = ({
  label,
  activeTab,
  activeBorderColor,
  handleTabClick,
}) => {
  return (
    <div
      onClick={() => handleTabClick(label)}
      style={{
        borderColor: activeTab === label ? activeBorderColor : "#D4D8E2",
      }}
      className="h-[45px] truncate w-full cursor-pointer px-[10px] bg-[#FFFFFFD4] rounded-[8px] border flex items-center justify-between"
    >
      <p className="text-[#000000] text-[14px] font-medium">{label}</p>
      <ChevronRight color="#000000" />
    </div>
  );
};

export default FilterCard;
